export default "__VITE_ASSET__BmtQvaGg__"